import { ResortCandidateHash, PrefectureCandidateHash, AreaCandidateHash, ResortCandidate, PrefectureCandidate, AreaCandidate } from '../../types';

function searchFromResort(keyword: string, locale: string, resortJson: ResortCandidateHash, prefectureJson: PrefectureCandidateHash, areaJson: AreaCandidateHash): ResortCandidate[] {
  let nameLocalResult = [] as ResortCandidate[];
  let codeResult = [] as ResortCandidate[];
  let nameEnResult = [] as ResortCandidate[];
  let otherResult = [] as ResortCandidate[];
  for (let [key, value] of Object.entries(resortJson)) {
    if (value["name"][locale].indexOf(keyword) != -1) {
      nameLocalResult.push(value);
      continue;
    }
    if (key.indexOf(keyword) != -1) {
      codeResult.push(value);
      continue;
    }
    if (value["name"]["en"].toLowerCase().indexOf(keyword) != -1) {
      nameEnResult.push(value);
      continue;
    }
    
    if (value["prefecture_codes"].some((prefectureCode) => prefectureCode.indexOf(keyword) != -1 || prefectureJson[prefectureCode]["name"]["en"].indexOf(keyword) != -1 || prefectureJson[prefectureCode]["name"][locale].indexOf(keyword) != -1 ) ||
        (!!areaJson[value["area_code"]] && value["area_code"].indexOf(keyword) != -1 ) || 
        (!!areaJson[value["area_code"]] && areaJson[value["area_code"]]["name"]["en"].indexOf(keyword) != -1) || 
        (!!areaJson[value["area_code"]] && areaJson[value["area_code"]]["name"][locale].indexOf(keyword) != -1)
      ) {
        otherResult.push(value);
    }
  }
  return nameLocalResult.concat(codeResult).concat(nameEnResult).concat(otherResult);
}

function searchFromPrefecture(keyword: string, locale: string, prefectureJson: PrefectureCandidateHash): PrefectureCandidate[] {
  let result = [] as PrefectureCandidate[];
  for (let [key, value] of Object.entries(prefectureJson)) {
    if (key.indexOf(keyword) != -1 ||
        value["name"]["en"].indexOf(keyword) != -1 || 
        value["name"][locale].indexOf(keyword) != -1) {
      result.push(value);
    }
  }
  return result;
}

function searchFromArea(keyword: string, locale: string, areaJson: AreaCandidateHash): AreaCandidate[] {
  let result = [] as AreaCandidate[];
  for (let [key, value] of Object.entries(areaJson)) {
    if (key.indexOf(keyword) != -1 ||
        value["name"]["en"].indexOf(keyword) != -1 || 
        value["name"][locale].indexOf(keyword) != -1) {
      result.push(value);
    }
  }
  return result;
}

export {
  searchFromResort,
  searchFromPrefecture,
  searchFromArea,
};